import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {Modal} from '../../modal/modal';
import {Stack, SxProps, Theme, Typography} from '@mui/material';

const subtitleSx: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '21px',
  letterSpacing: '0em',
  textAlign: 'center',
  color: 'var(--dcm-gray-general)',
};

const titleSx: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '0em',
  textAlign: 'center',
  color: 'var(--dcm-gray)',
};

const wrapperSx: SxProps<Theme> = {
  height: '215px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const innerWrapperSx: SxProps<Theme> = {
  display: 'flex',
  gap: '18px',
  width: '329px',
};

const modalSx: SxProps<Theme> = {
  marginBottom: 0,
  '.MuiPaper-root': {
    width: '554px',
    borderRadius: '16px',
  },
  '& > .MuiButtonBase-root': {
    lineHeight: '24px',
    height: '36px',
    width: '77px',
    paddingX: '14px',
    borderRadius: '5px',
  },
  '& > .MuiDialogContent-root': {
    paddingBottom: 0,
  },
};

type HandleTaskModalProps = {
  isSubmitting?: boolean;
  onClose?: () => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ResetModal = ({onCancel, onConfirm}: HandleTaskModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open
      actions={[
        {
          label: t(translations.care_and_activities.handle_task_modal.cancel),
          type: 'destructive',
          onClick: onCancel,
        },
        {
          label: t(translations.care_and_activities.handle_task_modal.undo),
          type: 'nondestructive',
          onClick: onConfirm,
        },
      ]}
      sx={modalSx}
      preventCloseClick
    >
      <Stack sx={wrapperSx}>
        <Stack sx={innerWrapperSx}>
          <Typography sx={titleSx}>
            {t(translations.shared.handle_care_task_modal.confirm_reset.title)}
          </Typography>
          <Typography sx={subtitleSx}>
            {t(translations.shared.handle_care_task_modal.confirm_reset.subtitle)}
          </Typography>
        </Stack>
      </Stack>
    </Modal>
  );
};

export const EditModal = ({isSubmitting, onCancel, onConfirm}: HandleTaskModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open
      actions={[
        {
          label: t(translations.care_and_activities.handle_task_modal.cancel),
          type: 'destructive',
          onClick: onCancel,
        },
        {
          label: t(translations.care_and_activities.handle_task_modal.confirm),
          type: 'nondestructive',
          onClick: onConfirm,
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      sx={modalSx}
      preventCloseClick
    >
      <Stack sx={wrapperSx}>
        <Stack sx={innerWrapperSx}>
          <Typography sx={titleSx}>
            {t(translations.shared.handle_care_task_modal.confirm_edit.title)}
          </Typography>
        </Stack>
      </Stack>
    </Modal>
  );
};

export const CancelEditModal = ({onClose, onCancel, onConfirm}: HandleTaskModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      onClose={onClose}
      open
      actions={[
        {
          label: t(translations.care_and_activities.handle_task_modal.cancel),
          type: 'destructive',
          onClick: onCancel,
        },
        {
          label: t(translations.care_and_activities.handle_task_modal.confirm),
          type: 'nondestructive',
          onClick: onConfirm,
        },
      ]}
      sx={modalSx}
      preventCloseClick
    >
      <Stack sx={wrapperSx}>
        <Stack sx={innerWrapperSx}>
          <Typography sx={titleSx}>
            {t(translations.shared.handle_care_task_modal.confirm_edit_cancel.title)}
          </Typography>
          <Typography sx={subtitleSx}>
            {t(translations.shared.handle_care_task_modal.confirm_edit_cancel.subtitle)}
          </Typography>
        </Stack>
      </Stack>
    </Modal>
  );
};
